'use strict';
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = require('../internals/document-create-element');

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;



//////////////////
// WEBPACK FOOTER
// ./~/react-fileupload-progress/~/core-js/internals/dom-token-list-prototype.js
// module id = 1389
// module chunks = 0